/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mImgCutter.vue?vue&type=template&id=054dad5f&scoped=true"
import script from "./mImgCutter.vue?vue&type=script&lang=js"
export * from "./mImgCutter.vue?vue&type=script&lang=js"
import style0 from "./mImgCutter.vue?vue&type=style&index=0&id=054dad5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054dad5f",
  null
  
)

export default component.exports